import { useComponentI18n } from '@rdrive/i18n';
import { getIconClass } from '@rdrive/helper-icon-class';
import messages from './messages/index.js';

export default (props) => {
  // LOCAL composer with the warn flags off — see @rdrive/i18n for why the flags are
  // assigned rather than passed.
  const { t } = useComponentI18n(messages);

  // Get subcategories for a specific category
  const getFilteredSubcategories = (categoryId) => {
    return Object.values(props.subcategories)
      .filter(subcategory =>
        subcategory.categoryId === categoryId &&
        props.statusCounts[categoryId]?.subcategories?.[subcategory.id]
      )
      .sort((a, b) => a.title.localeCompare(b.title));
  };

  // Largest counts first; closed/terminal statuses always at the end
  const getSortedStatuses = (statuses) => {
    return Object.values(statuses).sort((a, b) => {
      if (a.isTerminal !== b.isTerminal) {
        return a.isTerminal ? 1 : -1;
      }
      return b.count - a.count;
    });
  };

  // Function to open URL in new tab
  const openUrl = (url) => {
    window.open(url, '_blank');
  };

  return { t, getIconClass, getFilteredSubcategories, getSortedStatuses, openUrl };
};
